import { inject, Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import {
  Actions,
  createEffect,
  ofType,
  ROOT_EFFECTS_INIT,
} from '@ngrx/effects';
import { EMPTY, map, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { setCompany, setUser } from './app.actions';

@Injectable()
export class AppEffect {
  private readonly actions$ = inject(Actions);

  private readonly authService = inject(AuthService);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.authService.get().pipe(catchError(() => EMPTY))),
      map((user) => setUser(user))
    )
  );

  loadCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setUser),
      map((user) => setCompany(user?.compagnie ?? null))
    )
  );
}
